import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloud,
  faMitten,
  faMoneyCheck,
} from "@fortawesome/free-solid-svg-icons";

const ContractTypeIcon = ({ contractType, defaultToService=false }) => {

    var iconToUse = null;
    if (contractType && contractType === "SERVICE")
    {
        iconToUse = faMitten;
    }
    else if (contractType && contractType === "SAAS")
    {
        iconToUse = faCloud;
    }
    else if (contractType && contractType === "PAY_AS_YOU_GO")
    {
        iconToUse = faMoneyCheck;
    }

    if (iconToUse)
    {
        return <FontAwesomeIcon className="ms-1"  icon={iconToUse} />
    }

    if (defaultToService)
    {
        return <FontAwesomeIcon className="ms-1"  icon={faMitten} />
    }

    return <></>;
}

export default ContractTypeIcon;
